import { apiClient } from '../../../shared/api/client.js';

export const uibnApi = {
  async generateUibnPreview(publisherCode?: string, sequenceNumber?: number): Promise<{
    uibn: string;
    publisherCode: string;
    validation: { isValid: boolean; reason?: string };
    timestamp: string;
  }> {
    return apiClient('/api/uibn/preview', {
      method: 'POST',
      body: JSON.stringify({ publisherCode, sequenceNumber }),
    });
  },

  async previewUibn(publisherCode?: string, sequenceNumber?: number): Promise<{
    uibn: string;
    publisherCode: string;
    validation: { isValid: boolean; reason?: string };
    timestamp: string;
  }> {
    return this.generateUibnPreview(publisherCode, sequenceNumber);
  },

  async validateUibn(code: string): Promise<{
    isValid: boolean;
    reason?: string;
    parsed?: { prefix: string; publisherCode: string; sequence: string; checkDigit: number };
  }> {
    return apiClient(`/api/uibn/validate/${encodeURIComponent(code)}`);
  },

  async getCertificate(idOrUibn: string): Promise<{ success: boolean; certificate: any }> {
    return apiClient(`/api/uibn/certificate/${encodeURIComponent(idOrUibn)}`);
  },

  async verifyCertificateSignature(payload: {
    certNumber: string;
    uibn: string;
    bookId: string;
    title: string;
    userId: string;
    issuedAt: string;
    signatureData?: any;
  }): Promise<{ success: boolean; verification: any }> {
    return apiClient('/api/uibn/certificate/verify-signature', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
};
